import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import LoginTheme from './LoginTheme';
import styles from './LoginPage.module.css';
import { authClient } from '../../../lib/authClient';

export default function TwoFactorPage() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    authClient.twoFactor.sendOtp();
  }, []);

  const handleVerify = async () => {
    if (code.length < 6) return;
    setLoading(true);
    setError('');
    const { error } = await authClient.twoFactor.verifyOtp({ code });
    setLoading(false);
    if (error) {
      setError('Ungültiger oder abgelaufener Code.');
      setCode('');
    } else {
      navigate('/intern');
    }
  };

  return (
    <div className={styles.welcomePageContainer}>
      <div className={styles.box}>
        <h1>Zwei-Faktor-Authentifizierung</h1>
        <p>Ein Code wurde an deine E-Mail gesendet.</p>
        <div className={styles.loginContainer}>
          <ThemeProvider theme={LoginTheme}>
            <TextField
              fullWidth
              margin="normal"
              label="6-stelliger Code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              onKeyDown={(e) => e.key === 'Enter' && handleVerify()}
              error={!!error}
              helperText={error}
              inputProps={{ inputMode: 'numeric', maxLength: 6 }}
              autoFocus
            />
            <Button
              className={styles.loginButton}
              onClick={handleVerify}
              disabled={code.length < 6 || loading}
            >
              {loading ? 'Wird geprüft…' : 'Bestätigen'}
            </Button>
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
}
